import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { ComumModule } from './../../../shared/comum.module';
import { translateLoaderNBS } from './../../../shared/translate-loader/translateLoader';
import { GrupoEconomicoCadastroComponent } from './grupo-economico-cadastro/grupo-economico-cadastro.component';
import { GrupoEconomicoFiltroComponent } from './grupo-economico-filtro/grupo-economico-filtro.component';
import { GrupoEconomicoListaComponent } from './grupo-economico-lista/grupo-economico-lista.component';
import { GrupoEconomicoService } from './grupo-economico-service/grupo.economico.service';
import { GrupoEconomicoComponent } from './grupo-economico.component';


@NgModule({
  imports: [
    HttpModule,
    FormsModule,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    TranslateModule.forRoot(translateLoaderNBS)
  ],
  exports: [
    GrupoEconomicoComponent
  ],
  declarations: [
    GrupoEconomicoComponent,
    GrupoEconomicoCadastroComponent,
    GrupoEconomicoListaComponent,
    GrupoEconomicoFiltroComponent
  ],
providers: [
  GrupoEconomicoService
]
})
export class GrupoEconomicoModule { }
